module.exports = __webpack_public_path__ + "static/media/WiCanvas5dualstand_in.f57dcbeb.jpg";